<template>
  <div class="passo6">
    <modal name="chatDesabilitado" :adaptive="true" height="auto" :scrollable="true">
      <div class="container resumo-final-pf">
        <div class="colsm-12">
          <div class="tituloModal">Ops!</div>
          <p>Chat desativado, tente novamente mais tarde.</p>
        </div>
      </div>
    </modal>
    <div class="container wp-box section section-artigo with-box">
      <h2>Soluções para você</h2>

      <div class="timeline">
        <div id="timeline-wrap">
          <div id="timeline"></div>
          <div class="marker mfirst timeline-icon one active">1</div>
          <div class="marker m2 timeline-icon two active">2</div>
          <div class="marker m3 timeline-icon three active">3</div>
          <div class="marker m4 timeline-icon four active">4</div>
          <div class="marker m5 timeline-icon five active">5</div>
          <div class="marker mlast timeline-icon six active">6</div>
        </div>
      </div>
    </div>

    <div class="container wp-box section section-artigo with-box">
      
      <div class="row">
        <div class="colsm-12">
          <p>Agora que te conhecemos melhor, identificamos a oferta mais adequada para você.</p>
          <p><span class="texto-interno">Deseja alterar o valor simulado? Clique em Detalhes para ajustar a simulação.</span></p>
        </div>
      </div>
      
      
      <hr>

      <!-- PRODUTO 1 -->
      <div class="box-produtos" v-for="(p, index) in produtos" :key="index">
        <div class="container header-produto" style="">
          <div class="row">
            <div class="col-5 box-title">
              <div class="titulo-produto">{{p.Produto.vApelido}}</div>
              <div class="bt-detalhes" data-toggle="collapse" :data-target="'#conteudo-produto-' + p.iCodigo_Produto" aria-expanded="false" aria-controls="conteudo-produto-1">Detalhes &#9662;</div>
            </div>
            <div class="col box-values">
              <div class="titulo-valores">Limite simulado:<br><br></div>
              <div class="valor-produto azul limite-simulado">R$ {{formatPrice(p.Dados_Simulador.mValor_Simulado)}}</div>
            </div>
            <div class="col box-values" v-if="p.Dados_Simulador.nTaxa_Juros_Simulada">
              <div class="titulo-valores laranja">Taxa especial Caixa Sim:<br><br></div>
              <div class="valor-produto laranja">
                <span style="font-size: 12px;" v-if="p.iCodigo_Produto != 195">A partir de:</span>
                <span style="font-size: 12px;" v-if="p.iCodigo_Produto == 195">Taxa máxima de:</span>
                {{p.Dados_Simulador.nTaxa_Juros_Simulada}}% a.m.</div>
            </div>
            <!-- <div class="col box-values">
              <div class="titulo-valores" v-if="p.Dados_Simulador.nTaxa_Juros_Simulada">Taxa fora do Caixa SIM (%):</div>
              <div class="valor-produto azul">{{p.nTaxa_Juros_Sem_Programa}}</div>
            </div> -->
          </div>
        </div>
        
        <div class="collapse" :id="'conteudo-produto-' + p.iCodigo_Produto">
          <div class="container">
            <p v-if="p.iCodigo_Produto != 195 && p.iCodigo_Produto != 5616 && p.iCodigo_Produto != 400">Esse produto é opcional. Caso não deseje realizar a contratação, clique em "Não incluir este produto" no box abaixo.</p>
            <p><span class="texto-interno">{{p.Produto.vDescricao_Breve}}</span></p>

            <div v-if="p.Produto.bE_Simulavel">
              <p><span class="texto-interno">Use os controles do painel abaixo para alterar os valores.</span></p>
              
              <div class="row">
                <div class="col-7 slider-valores" style="margin: 20px;">
                  <label class="label-d espacamento-label">Valor Total</label>
                  <vue-slider :min="parseInt(p.Dados_Simulador.mValor_Minimo) - 1" :lazy="true" :tooltip="'always'" :tooltipStyle="'{background: #F7941E;}'"  :max="parseInt(p.Dados_Simulador.mValor_Maximo) + 1" :dotSize="5" v-model="p.Dados_Simulador.mValor_Simulado" @change="refazerSimulacaoValor(p)">
                    <template v-slot:tooltip="{ value, focus }">
                      <div :class="['custom-tooltip', { focus }]"> {{ 'R$' + formatPrice(parseInt(value)) }}</div>
                    </template>
                  </vue-slider>

                  <label class="label-d espacamento-label">Prazo</label>
                  <vue-slider :min="p.Dados_Simulador.iPrazo_Minimo" :lazy="true" :tooltip="'always'" :tooltipStyle="'{background: #F7941E;}'" :tooltip-formatter="'{value}'" :max="p.Dados_Simulador.iPrazo_Maximo" :dotSize="5" v-model="p.Dados_Simulador.iPrazo_Simulado" @change="refazerSimulacaoPrazo(p)">
                    <template v-slot:tooltip="{ value, focus }">
                      <div :class="['custom-tooltip', { focus }]"> {{+ value }}</div>
                    </template>
                  </vue-slider>
                  

                  <label class="label-d espacamento-label">Valor da parcela</label>
                  <vue-slider :min="parseInt(p.Dados_Simulador.mParcela_Minima) - 1" :lazy="true" :tooltip="'always'" :tooltipStyle="'{background: #F7941E;}'"  :max="parseInt(p.Dados_Simulador.mParcela_Maxima) + 1" :dotSize="5" v-model="p.Dados_Simulador.mParcela_Simulada" @change="refazerSimulacaoParcela(p)">
                    <template v-slot:tooltip="{ value, focus }">
                      <div :class="['custom-tooltip', { focus }]"> {{ 'R$' + formatPrice(parseInt(value)) }}</div>
                    </template>
                  </vue-slider>
                  
                  
                </div>
                <div class="col">
                  <div class="bloco-resultado">
                    <div>Valor total (R$): <span>R$ {{formatPrice(parseInt(p.Dados_Simulador.mValor_Simulado))}}</span></div>
                    <div>Prazo (Meses): <span>{{p.Dados_Simulador.iPrazo_Simulado}}</span></div>
                    <div>Valor da parcela (R$): <span>R$ {{formatPrice(parseInt(p.Dados_Simulador.mParcela_Simulada))}}</span></div>
                    <div>Taxa de juros (%): <span>{{p.Dados_Simulador.nTaxa_Juros_Simulada}} % a.m.</span></div>
                    <div v-if="p.iCodigo_Produto != 195 && p.iCodigo_Produto != 5616 && p.iCodigo_Produto != 400">
                      <label class="label-d"></label>
                      <input type="checkbox" class="form-check-input" @change="check($event, p)" name="" id="" v-model="removerProduto">
                      Não incluir este produto
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>

            <div class="row cartoes" v-if="p.iCodigo_Produto == 5616">
              <div class="colsm-4 cartao">
                <img :src="p.Produto.vImagem_Produto">
                <div class="titulo-cartao">{{p.Produto.vApelido}}</div>
                <div class="resumo-cartao">{{p.Produto.vDescricao}}</div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="avisoNoMix">{{messagemErro.Message}}</p>

      <p class="aviso"><img src="http://www.caixa.gov.br/PublishingImages/Caixa_Sim/error-triangle.png">  ATENÇÃO:  Esta oferta é apenas uma <strong>simulação</strong>, sujeita à aprovação de crédito e adesão ao Caixa SIM. Informações quanto ao Custo Efetivo Total (CET) e Tarifa de Abertura de Crédito (TAC) serão descritas no momento da contratação.</p>
      
    </div>

    <div class="container wp-box section section-artigo with-box">
      <div class="row">
        <div class="colsm-12">
          <div class="titulo_section">Solicitar contratação</div>
          <div class="conteudo_section">
            <p class="texto-maior">Seu número de protocolo é: {{dados.vProtocolo}}</p>
            <p v-bind:class="{ alerta: isFechado }">O chat funciona em dias úteis, das {{horaInicio}}h às {{horaTermino}}h.</p>
            <p>Ao continuar, você autoriza o fornecimento dos seus dados para a consulta de crédito e a troca das suas informações cadastrais entre as empresas do conglomerado Caixa, assim como o contato proativo do banco. </p>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="colsm-8">
          <a class="btn orange" v-if="!disableChatButton" :disable=disableChatButton @click="validarAvancar(dados)">{{textButtom}}</a> 
          ou <router-link :to="{name: 'passo-cinco', params: {dados}}" >volte à etapa anterior</router-link>
        </div>
      </div>
    </div>
       
  </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';
import {chatMixin} from '../../chat';

export default {
  mixins:[chatMixin],
  components: {},
  name: 'passo6',
  data: function() {
    return {
      valor_imovel: 0,
      imovel: 0,
      valor_investimento: 0,
      investimento: 0,
      valor_carro: 0,
      carro: 0,
      nenhuma: 0,
      prazo: 0,
      valor_total: 0,
      valor_parcela: 0,
      removerProduto: false,
      dados: {},
      produtos: null,
      urlApi: process.env.VUE_APP_URL_API,
      urlChat: null,
      isFechado: false,
      configs: null,
      horaInicio: 8,
      horaTermino: 18,
      disableChatButton: false,
      messagemErro: { 
        HasProductMix: true,
        Message: ""
      },
      textButtom: "Acessar o chat"
    };
  },
  methods: {
    validarAvancar(dados) {
      var _this = this;
      if(moment().isBetween(moment(this.configs.dHora_Inicio_Chat, "HH:mm:ss"),moment(this.configs.dHora_Termino_Chat, "HH:mm:ss"))){
          
          this.disableChatButton = true;
          this.abrirAtendimento(this.dados.vCPF, this.dados.vProtocolo, this.dados.Nome,this.dados.vToken);

          if(this.configs.bMostrar_Chat){

            try{
              dataLayer.push({
                'passoSimulador': 'Passo7',
                'produtos_valores': _this.dados,
                'event': 'acessarChat',
                'tipo': 'PF'
              });
            } catch(error){
              console.error(error);
            }

          this.abrirAtendimento(this.dados.vCPF, this.dados.vProtocolo, this.dados.Nome,this.dados.vToken);
          
        } else {
          this.$modal.show("chatDesabilitado");
          alert("O Chat nesse momento está indisponível, tente mais tarde");
          _this.disableChatButton = true;
        }
               
      } else {
        this.isFechado = true;
        alert(`O Chat nesse momento está indisponível, seu horário de funcionamento, em dias úteis, são das ${_this.configs.dHora_Inicio_Chat} às ${_this.configs.dHora_Termino_Chat}.`);
        _this.disableChatButton = true;
      }

    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    check(e, dado){
      var _this = this;
      _this.$loading(true);

      if(e.target.checked){
        var simular = {
        "Tipo_Simulacao": "Valor",
        "iID_Visita" : dado.Dados_Simulador.iID_Visita,
        "iCodigo_Produto": dado.Dados_Simulador.iCodigo_Produto,
        "mValor_Minimo": dado.Dados_Simulador.mValor_Minimo,
        "mValor_Simulado": dado.Dados_Simulador.mValor_Simulado,
        "mValor_Maximo": dado.Dados_Simulador.mValor_Maximo,
        "iPrazo_Minimo": dado.Dados_Simulador.iPrazo_Minimo,
        "iPrazo_Simulado": dado.Dados_Simulador.iPrazo_Simulado,
        "iPrazo_Maximo": dado.Dados_Simulador.iPrazo_Maximo,
        "mParcela_Minima": dado.Dados_Simulador.mParcela_Minima,
        "mParcela_Simulada": dado.Dados_Simulador.mParcela_Simulada,
        "mParcela_Maxima": dado.Dados_Simulador.mParcela_Maxima,
        "nTaxa_Juros_Simulada": dado.Dados_Simulador.nTaxa_Juros_Simulada,
        "bMarcou_Retirar_Esse_Produto": true ,
        "bE_Simulacao_Final": false
        };
      } else {
        var simular = {
        "Tipo_Simulacao": "Valor",
        "iID_Visita" : dado.Dados_Simulador.iID_Visita,
        "iCodigo_Produto": dado.Dados_Simulador.iCodigo_Produto,
        "mValor_Minimo": dado.Dados_Simulador.mValor_Minimo,
        "mValor_Simulado": dado.Dados_Simulador.mValor_Simulado,
        "mValor_Maximo": dado.Dados_Simulador.mValor_Maximo,
        "iPrazo_Minimo": dado.Dados_Simulador.iPrazo_Minimo,
        "iPrazo_Simulado": dado.Dados_Simulador.iPrazo_Simulado,
        "iPrazo_Maximo": dado.Dados_Simulador.iPrazo_Maximo,
        "mParcela_Minima": dado.Dados_Simulador.mParcela_Minima,
        "mParcela_Simulada": dado.Dados_Simulador.mParcela_Simulada,
        "mParcela_Maxima": dado.Dados_Simulador.mParcela_Maxima,
        "nTaxa_Juros_Simulada": dado.Dados_Simulador.nTaxa_Juros_Simulada,
        "bMarcou_Retirar_Esse_Produto": false,
        "bE_Simulacao_Final": false
        };
      }

      axios
      .post(_this.urlApi + 'Simulador/' + dado.Dados_Simulador.iCodigo_Produto, simular)
      .then(response => {

        dado.Dados_Simulador.mValor_Minimo = response.data.mValor_Minimo;
        dado.Dados_Simulador.mValor_Simulado = response.data.mValor_Simulado;
        dado.Dados_Simulador.mValor_Maximo = response.data.mValor_Maximo;
        dado.Dados_Simulador.iPrazo_Minimo = response.data.iPrazo_Minimo;
        dado.Dados_Simulador.iPrazo_Simulado = response.data.iPrazo_Simulado;
        dado.Dados_Simulador.iPrazo_Maximo = response.data.iPrazo_Maximo;
        dado.Dados_Simulador.mParcela_Minima = response.data.mParcela_Minima;
        dado.Dados_Simulador.mParcela_Simulada = response.data.mParcela_Simulada;
        dado.Dados_Simulador.mParcela_Maxima = response.data.mParcela_Maxima;
        dado.Dados_Simulador.nTaxa_Juros_Simulada = response.data.nTaxa_Juros_Simulada;

          _this.$loading(false);
        }
      )
      .catch(error => {
        
        _this.$loading(false);
      })
      
    },
    refazerSimulacaoValor(dado){
      var _this = this;
      _this.$loading(true);
      var simular = {
        "Tipo_Simulacao": "Valor",
        "iID_Visita" : dado.Dados_Simulador.iID_Visita,
        "iCodigo_Produto": dado.Dados_Simulador.iCodigo_Produto,
        "mValor_Minimo": dado.Dados_Simulador.mValor_Minimo,
        "mValor_Simulado": dado.Dados_Simulador.mValor_Simulado,
        "mValor_Maximo": dado.Dados_Simulador.mValor_Maximo,
        "iPrazo_Minimo": dado.Dados_Simulador.iPrazo_Minimo,
        "iPrazo_Simulado": dado.Dados_Simulador.iPrazo_Simulado,
        "iPrazo_Maximo": dado.Dados_Simulador.iPrazo_Maximo,
        "mParcela_Minima": dado.Dados_Simulador.mParcela_Minima,
        "mParcela_Simulada": dado.Dados_Simulador.mParcela_Simulada,
        "mParcela_Maxima": dado.Dados_Simulador.mParcela_Maxima,
        "nTaxa_Juros_Simulada": dado.Dados_Simulador.nTaxa_Juros_Simulada,
        "bMarcou_Retirar_Esse_Produto": false,
        "bE_Simulacao_Final": false
      };

      axios
      .post(_this.urlApi + 'Simulador/' + dado.Dados_Simulador.iCodigo_Produto, simular)
      .then(response => {

        dado.Dados_Simulador.mValor_Minimo = response.data.mValor_Minimo;
        dado.Dados_Simulador.mValor_Simulado = response.data.mValor_Simulado;
        dado.Dados_Simulador.mValor_Maximo = response.data.mValor_Maximo;
        dado.Dados_Simulador.iPrazo_Minimo = response.data.iPrazo_Minimo;
        dado.Dados_Simulador.iPrazo_Simulado = response.data.iPrazo_Simulado;
        dado.Dados_Simulador.iPrazo_Maximo = response.data.iPrazo_Maximo;
        dado.Dados_Simulador.mParcela_Minima = response.data.mParcela_Minima;
        dado.Dados_Simulador.mParcela_Simulada = response.data.mParcela_Simulada;
        dado.Dados_Simulador.mParcela_Maxima = response.data.mParcela_Maxima;
        dado.Dados_Simulador.nTaxa_Juros_Simulada = response.data.nTaxa_Juros_Simulada;

          _this.$loading(false);
        }
      )
      .catch(error => {
        
        _this.$loading(false);
      })

    },
    refazerSimulacaoPrazo(dado){
      var _this = this;
      _this.$loading(true);
      var simular = {
        "Tipo_Simulacao": "Valor",
        "iID_Visita" : dado.Dados_Simulador.iID_Visita,
        "iCodigo_Produto": dado.Dados_Simulador.iCodigo_Produto,
        "mValor_Minimo": dado.Dados_Simulador.mValor_Minimo,
        "mValor_Simulado": dado.Dados_Simulador.mValor_Simulado,
        "mValor_Maximo": dado.Dados_Simulador.mValor_Maximo,
        "iPrazo_Minimo": dado.Dados_Simulador.iPrazo_Minimo,
        "iPrazo_Simulado": dado.Dados_Simulador.iPrazo_Simulado,
        "iPrazo_Maximo": dado.Dados_Simulador.iPrazo_Maximo,
        "mParcela_Minima": dado.Dados_Simulador.mParcela_Minima,
        "mParcela_Simulada": dado.Dados_Simulador.mParcela_Simulada,
        "mParcela_Maxima": dado.Dados_Simulador.mParcela_Maxima,
        "nTaxa_Juros_Simulada": dado.Dados_Simulador.nTaxa_Juros_Simulada,
        "bMarcou_Retirar_Esse_Produto": false,
        "bE_Simulacao_Final": false
      };

      axios
      .post(_this.urlApi + 'Simulador/' + dado.Dados_Simulador.iCodigo_Produto, simular)
      .then(response => {

        dado.Dados_Simulador.mValor_Minimo = response.data.mValor_Minimo;
        dado.Dados_Simulador.mValor_Simulado = response.data.mValor_Simulado;
        dado.Dados_Simulador.mValor_Maximo = response.data.mValor_Maximo;
        dado.Dados_Simulador.iPrazo_Minimo = response.data.iPrazo_Minimo;
        dado.Dados_Simulador.iPrazo_Simulado = response.data.iPrazo_Simulado;
        dado.Dados_Simulador.iPrazo_Maximo = response.data.iPrazo_Maximo;
        dado.Dados_Simulador.mParcela_Minima = response.data.mParcela_Minima;
        dado.Dados_Simulador.mParcela_Simulada = response.data.mParcela_Simulada;
        dado.Dados_Simulador.mParcela_Maxima = response.data.mParcela_Maxima;
        dado.Dados_Simulador.nTaxa_Juros_Simulada = response.data.nTaxa_Juros_Simulada;
        
          _this.$loading(false);
        }
      )
      .catch(error => {
        
        _this.$loading(false);
      })



    },
    refazerSimulacaoParcela(dado){
      var _this = this;
      _this.$loading(true);
      var simular = {
        "Tipo_Simulacao": "Prestação",
        "iID_Visita" : dado.Dados_Simulador.iID_Visita,
        "iCodigo_Produto": dado.Dados_Simulador.iCodigo_Produto,
        "mValor_Minimo": dado.Dados_Simulador.mValor_Minimo,
        "mValor_Simulado": dado.Dados_Simulador.mValor_Simulado,
        "mValor_Maximo": dado.Dados_Simulador.mValor_Maximo,
        "iPrazo_Minimo": dado.Dados_Simulador.iPrazo_Minimo,
        "iPrazo_Simulado": dado.Dados_Simulador.iPrazo_Simulado,
        "iPrazo_Maximo": dado.Dados_Simulador.iPrazo_Maximo,
        "mParcela_Minima": dado.Dados_Simulador.mParcela_Minima,
        "mParcela_Simulada": dado.Dados_Simulador.mParcela_Simulada,
        "mParcela_Maxima": dado.Dados_Simulador.mParcela_Maxima,
        "nTaxa_Juros_Simulada": dado.Dados_Simulador.nTaxa_Juros_Simulada,
        "bMarcou_Retirar_Esse_Produto": false,
        "bE_Simulacao_Final": false
      };

      axios
      .post(_this.urlApi + 'Simulador/' + dado.Dados_Simulador.iCodigo_Produto, simular)
      .then(response => {

        dado.Dados_Simulador.mValor_Minimo = response.data.mValor_Minimo;
        dado.Dados_Simulador.mValor_Simulado = response.data.mValor_Simulado;
        dado.Dados_Simulador.mValor_Maximo = response.data.mValor_Maximo;
        dado.Dados_Simulador.iPrazo_Minimo = response.data.iPrazo_Minimo;
        dado.Dados_Simulador.iPrazo_Simulado = response.data.iPrazo_Simulado;
        dado.Dados_Simulador.iPrazo_Maximo = response.data.iPrazo_Maximo;
        dado.Dados_Simulador.mParcela_Minima = response.data.mParcela_Minima;
        dado.Dados_Simulador.mParcela_Simulada = response.data.mParcela_Simulada;
        dado.Dados_Simulador.mParcela_Maxima = response.data.mParcela_Maxima;
        dado.Dados_Simulador.nTaxa_Juros_Simulada = response.data.nTaxa_Juros_Simulada;
        
          _this.$loading(false);
        }
      )
      .catch(error => {
        
        _this.$loading(false);
      })
    },


  },
  created: function(){
    var _this = this;
    _this.$loading(true)
    _this.dados = _this.$route.params.dados;

    _this.$loading(true);

    axios
      .get(_this.urlApi + "Parametros_Gerais")
      .then(function(response) {
        _this.configs = response.data;
        _this.horaInicio = moment(response.data.dHora_Inicio_Chat, "HH:mm:ss").format("H");
        _this.horaTermino = moment(response.data.dHora_Termino_Chat, "HH:mm:ss").format("H");
        if(!response.data.bMostrar_Chat){
          _this.disableChatButton = true;
          //_this.isFechado = true;
          //alert("O Chat nesse momento está indisponível, tente mais tarde");
          _this.textButtom = "Chat indisponível";
        } 
        if(!moment().isBetween(moment(_this.configs.dHora_Inicio_Chat, "HH:mm:ss"),moment(_this.configs.dHora_Termino_Chat, "HH:mm:ss"))){
          _this.disableChatButton = true;
          //_this.isFechado = true;
          //alert(`O Chat nesse momento está indisponível, seu horário de funcionamento, em dias úteis, são das ${_this.configs.dHora_Inicio_Chat}h às ${_this.configs.dHora_Termino_Chat}h.`);
          _this.textButtom = `Horário de funcionamento chat: das ${_this.configs.dHora_Inicio_Chat}h às ${_this.configs.dHora_Termino_Chat}h.`;
        }
        //_this.$loading(false);
      })
      .catch(function(error) {
        _this.erroApi = true;
        //_this.$loading(false);
      });


    if(_this.dados.vToken){
      //_this.urlChat = "http://chatdigital.des.caixa.gov.br/" /* +
      //"?cpf=" + _this.dados.vCPF + 
      //"&protocolo=" + _this.dados.vProtocolo +
      //"&token=" + _this.dados.vToken;*/
    } else {
      //_this.urlChat = "http://chatdigital.des.caixa.gov.br/" /*+
      //"?cpf=" + _this.dados.vCPF + 
      //"&protocolo=" + _this.dados.vProtocolo;*/
    }
    _this.$loading(true);
    axios
      .post(_this.urlApi + 'MixDoCliente',{
        iID_Visita:  _this.dados.iID_Visita
      })
      .then(response => {
          _this.produtos = response.data;
          if(!_this.isFechado)
            this.disableChatButton = false;
          this.$loading(false);
        }
      )
      .catch(error => {
        if (error.response) {
            this.messagemErro = error.response.data;
            this.disableChatButton = true;
            alert(this.messagemErro.Message)
        }
        this.$loading(false);
      })
  }
}

</script>

<style scoped lang="scss">

.box-produtos{

  background-color: #F3F5F9;
  border: 1px solid #C8CBD4;
  margin-bottom: 6px;
}
.titulo-produto{
  color: #0164A8;
  font-family: 'futura-lt-bold';
  font-size: 22px;
}
.bt-detalhes{
  color: #F7941E;
  font-size: 16px;
  cursor: pointer;
}
.titulo-valores{
  font-size: 16px;
  text-align: center;
  font-family: 'helveticaregular';
  color: #4C556C;
  margin-top: -20px;
}
.valor-produto{
  font-size: 25px;
  text-align: center;
  font-family: 'futura-lt-book';
}
.azul{
  color: #0164A8;
}
.laranja {
  color: #F7941E;
}
.header-produto{
  padding-bottom: 15px;
  border-bottom: 1px solid #C8CBD4;
}
.texto-interno{
  color: #4C556C;
  font-size: 16px;
  font-family: 'helveticaregular';
}
.bloco-resultado{
  background: #FFFFFF;
  padding: 15px;
  color: #4C556C;
  font-family: 'helveticaregular';
  font-size: 16px;
  line-height: 40px;
}
.bloco-resultado span{
  color: #0164A8;
  font-size: 25px;
  font-family: 'futura-lt-book';
  float: right;
  height: 0;
}
.custom-tooltip {
  position: relative;
	background: #F7941E;
  border-radius: 5px;
  color: #FFFFFF;
  padding: 5px;
  font-family: 'futura-lt-bold';
  font-size: 12px;
}
.custom-tooltip:after{
  	top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(247, 148, 30, 0);
    border-top-color: #F7941E;
    border-width: 6px;
    margin-left: -6px;
}

.espacamento-label{
  margin-bottom: 35px;
  margin-top: 20px;
}
.cartao{
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.cartao img {
  width: 240px;
}
.titulo-cartao{
  color: #0164A8;
  font-size: 25px;
  font-family: 'futura-lt-book';
}
.resumo-cartao{
  color: #4C556C;
  font-size: 16px;
  font-family: 'helveticaregular';
}
.anuidade-cartao{
  color: #4C556C;
  font-size: 16px;
  font-family: 'helveticaregular';
}
.aviso{
  color: #4C546D;
  font-family: 'futura-lt-book';
  font-size: 12px;
  margin-top: 30px;
}
.avisoNoMix{
  color: red;
  font-family: 'futura-lt-book';
  font-size: 25px;
  margin-top: 30px;
}
.titulo_section{
  font-size: 20px;
  color: #1F2A47;
  margin-bottom: 20px;
}
.conteudo_section p{
  color: #4C556C;
  font-size: 16px;
  font-family: 'helveticaregular';
}
.bloco-resultado{
  margin-top: 30px;
}
.bloco-resultado span{
  font-size: 20px;
}

.texto-maior {
  color: #1F2A47 !important;
  font-size: 19px !important;
  font-family: 'futura-lt-book' !important;
  margin-bottom: 20px !important;
}
.titulo_section{
  font-size: 20px;
  color: #0164A8;
  margin-bottom: 20px;
}
.alerta{
  color: red;
  font-family: 'futura-lt-book';
  font-size: 25px;
}


/*  TABLET */
@media only screen and (max-width: 1026px) {

}

@media only screen and (max-width: 770px){
  .slider-valores{
    margin: 0 !important;
    width: 100%;
    max-width: 100%;
    display: block;
    flex: none;
    padding-left: 30px;
    padding-right: 30px;
  }

}
/* MOBILE */

/* IPHONE 6 PLUS*/
@media only screen and (max-width: 645px) {


}
/* IPHONE 6 */
@media only screen and (max-width: 480px) {
  .box-title{
    float: left;
    width: 100%;
    max-width: 100%;
    flex: none;
  }
  .box-values{
    max-width: 33.33%;
  }
  .titulo-valores{
    font-size: 12px;
    margin-top: 15px;
  }
  .valor-produto{
    font-size: 20px;
  }
  .limite-simulado{
    margin-top: -15px;
  }
  .slider-valores{
    max-width: 100%;
    flex: none;
    margin: 0 !important;
    padding-left: 40px;
    padding-right: 40px;
  }

}

/* IPHONE 5*/
@media only screen and (max-width: 328px) {

}


</style>
